<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header">{{ title }}</h3>
    <button
      type="button"
      class="close"
      attr.aria-label="{{ title }} Close"
      ngbAutoFocus
      (click)="activeModal.dismiss('Cross click')"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    @if (!isLoading) {
      <div class="safe-html" [innerHTML]="body | safeHtml: 'html'"></div>
    }
    @if (isLoading) {
      <div>
        <app-loading-spinner size="sm" />
      </div>
    }
  </div>
  <div class="modal-footer">
    @if (options.buttonCancel) {
      <button
        type="button"
        appButton="small"
        class="small-button--no"
        (click)="activeModal.close(false)"
      >
        {{ options.buttonCancelText }}
      </button>
    }
    @if (options.buttonOk) {
      <button type="button" id="button_ok" appButton="small" (click)="buttonOkAction()">
        {{ options.buttonOkText }}
      </button>
    }
  </div>
</div>
